import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Rails from '@rails/ujs';

window.Swal = Swal;
// Behavior after click to confirm button
const confirmed = (element, result) => {
    if (result.value) {
        if (!!element.getAttribute('data-remote')) {
            let reloadAfterSuccess = true;
            if(element.getAttribute('href')){
                $.ajax({
                    method: element.getAttribute('data-method'),
                    url: element.getAttribute('href'),
                    dataType: 'json',
                    success: function(result) {
                        Swal.fire('Success!', result.message || '', 'success')
                            .then((_result) => {
                                if (reloadAfterSuccess) {
                                    if (result.redirect_path == null){
                                        window.location.reload();
                                    } else{
                                        window.location.assign(result.redirect_path)
                                    }
                                }
                            });
                    },
                    error: function(xhr) {
                        let title   = 'Error!';
                        let message = 'Something went wrong. Please try again later.';

                        if (xhr.responseJSON && xhr.responseJSON.message) {
                            message = xhr.responseJSON.message;
                        }

                        Swal.fire(title, message,'error');
                    }
                });
            } // end if
        } else {
            element.removeAttribute('data-confirm-swal');
            element.click();
        }
    }
};

// Display the confirmation dialog
const showConfirmationDialog = (element) => {
    const message = element.getAttribute('data-confirm-swal');
    const text    = element.getAttribute('data-text');

    Swal.fire({
        title:             message || 'Are you sure?',
        text:              text || '',
        icon: 'warning',
        confirmButtonColor: '#E6596F',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消'
    }).then(result => confirmed(element, result));
};

const allowAction = (element) => {
    if (element.getAttribute('data-confirm-swal') === null) {
        return true;
    }

    showConfirmationDialog(element);
    return false;
};

function handleConfirm(element) {
    if (!allowAction(this)) {
        Rails.stopEverything(element);
    }
}

Rails.delegate(document, 'a[data-confirm-swal]', 'click', handleConfirm);